import { labelids } from "../../assets/data/TkExplanationProperty";
import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "info",
    type: "explanatoryText",
    explanatoryText: labelids.labelid.LBLC010004_01,
    explanatoryTextRule: "\\n",
  },
  {
    title: `共済契約者番号`,
    keyword: "mutualAidContractNumber",
    type: "label",
    requiredIcon: true,
    inputProps: { minLength: 6, maxLength: 6 },
  },
  {
    title: `共済契約者名`,
    keyword: "mutualAidPolicyholderName",
    type: "label",
    requiredIcon: true,
  },
  {
    title: `本部所在地郵便番号`,
    keyword: "zipcode",
    type: "addressSearch",
    requiredIcon: true,
    inputProps: { maxLength: 7 },
  },
  {
    requiredIcon: true,
    keyword: "locationGroup",
    title: "本部所在地",
    type: "locationGroup",
    valueObject: {
      prefectures: "",
      city: "",
      address: "",
    },
  },
  {
    title: `担当者氏名`,
    keyword: "personInChargeName",
    type: "name",
    requiredIcon: true,
  },
  {
    title: `本システムで使用するメールアドレス`,
    keyword: "emailAddressUsedInThisSystem",
    type: "mail",
    requiredIcon: true,
  },
  {
    title: `本システムで使用するメールアドレス（確認用）`,
    keyword: "emailAddressUsedInThisSystemForConfirmation",
    type: "mail",
    requiredIcon: true,
    showLine: true,
  },
  {
    title: `連絡先電話番号`,
    keyword: "contactPhoneNumber",
    type: "phoneNum",
    requiredIcon: true,
    inputProps: { maxLength: 14 },
  },
  {
    title: `連絡先FAX番号`,
    keyword: "contactFAX",
    type: "phoneNum",
    inputProps: { maxLength: 14 },
  },
  {
    title: `その他連絡事項`,
    keyword: "others",
    type: "textarea",
  },
];
const schema = {
  mutualAidContractNumber: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    minLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "6"),
    },

    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
  },
  mutualAidPolicyholderName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
  zipcode: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    minLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
    maxLength: {
      value: 7,
      message: TkPropertyMessageGet("TKMSG_SCR0077E", "7"),
    },
  },
  locationGroup: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    validate: (data: any) => {
      const errorCheckers = {
        prefectures: (value: string) => {
          if (!value) return TkPropertyMessageGet("TKMSG_SCR0043E");
          return "";
        },
        city: (value: string) => {
          if (!value) return TkPropertyMessageGet("TKMSG_SCR0043E");
          if (value.length > 20)
            return TkPropertyMessageGet("TKMSG_SCR0046E", "20");
          // eslint-disable-next-line no-control-regex
          if (!value.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/))
            return TkPropertyMessageGet("TKMSG_SCR0061E");
          return "";
        },
        address: (value: string) => {
          if (!value) return TkPropertyMessageGet("TKMSG_SCR0043E");
          if (value.length > 85)
            return TkPropertyMessageGet("TKMSG_SCR0046E", "85");
          // eslint-disable-next-line no-control-regex
          if (!value.match(/^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/))
            return TkPropertyMessageGet("TKMSG_SCR0061E");
          return "";
        },
      };

      let error = {
        prefectures: errorCheckers.prefectures(data.prefectures),
        city: errorCheckers.city(data.city),
        address: errorCheckers.address(data.address),
      };

      if (Object.values(error).every((value) => !value)) {
        return true;
      }

      return JSON.stringify(error);
    },
  },
  personInChargeName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
  },
  emailAddressUsedInThisSystem: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  emailAddressUsedInThisSystemForConfirmation: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
    maxLength: {
      value: 85,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "85"),
    },
  },
  contactPhoneNumber: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 21,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "21"),
    },
  },
  contactFAX: {
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
    maxLength: {
      value: 21,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "21"),
    },
  },
  others: {
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
    maxLength: {
      value: 500,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "500"),
    },
  },
};

export { schema, fakeTableList };
